<template>
  <b-form-group
    label="Vizyon Başlık"
    label-for="vision_title"
  >
    <validation-provider
      #default="{ errors }"
      name="Vizyon Başlık"
      rules="required"
    >
      <b-form-input
        id="vision_title"
        v-model="itemData.vision_title"
        placeholder="Vizyon Başlık"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import { BFormGroup, BFormInput } from 'bootstrap-vue'

export default {
  name: 'VisionTitle',
  components: {
    BFormGroup,
    BFormInput,
    ValidationProvider,
  },
  computed: {
    itemData() {
      return this.$store.getters['about/dataItem']
    },
  },
}
</script>
